import { useFormContext } from 'react-hook-form';
import { IDefaultControlProps } from '../../Form';
import BaseControl from '../BaseControl/BaseControl';

interface ITextInputProps extends IDefaultControlProps {
  type?: 'text' | 'email' | 'password';
  pattern?: string;
}

const TextInput = (props: ITextInputProps) => {
  const {
    name,
    label,
    placeholder,
    disabled,
    type = 'text',
    autoComplete,
    className,
    group,
    pattern
  } = props;
  const { register } = useFormContext();

  return (
    <BaseControl name={name} label={label} className={className} group={group}>
      <input
        {...register(name)}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        pattern={pattern}
      />
    </BaseControl>
  );
};

export default TextInput;
